import { useQuery } from '@apollo/client';
import {gql} from "@apollo/client";

// Collections 목록을 가져오는 GraphQL 쿼리 정의
export const GET_COLLECTIONS = gql`
  query getCollectionsCached($offset: Int, $limit: Int) {
    getCollectionsCached(offset: $offset, limit: $limit) {
      id
      title
      subtitle
      description
      resizedSmallImage
      resizedBigImage
      link
      featured_from
      featured_until
      priority
      view_count
      createdAt
      updatedAt
      aspect_ratio
      image_caption
      sub_header
    }
  }
`;

// Collections 목록을 무한 스크롤로 가져오는 커스텀 훅
export default function useCollections(limit = 20, options = {}) {
  const { skip = false } = options;
  const { loading, error, data, fetchMore } = useQuery(GET_COLLECTIONS, {
    variables: { offset: 0, limit },
    notifyOnNetworkStatusChange: true,
    skip,
  });

  // 더 많은 컬렉션을 로드하는 함수
  const loadMore = () => {
    if (loading || !data) return;

    const currentLength = data.getCollectionsCached.length;

    fetchMore({
      variables: {
        offset: currentLength,
        limit,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        return {
          getCollectionsCached: [
            ...prev.getCollectionsCached,
            ...fetchMoreResult.getCollectionsCached,
          ],
        };
      },
    });
  };

  // 더 로드할 컬렉션이 있는지 여부
  const hasMore = data && data.getCollectionsCached && data.getCollectionsCached.length > 0 &&
    data.getCollectionsCached.length % limit === 0;

  return {
    loading,
    error,
    collections: data && data.getCollectionsCached ? data.getCollectionsCached : [],
    loadMore,
    hasMore,
  };
}
